<template>
	<div class="page container">
		<v2-back-btn />
		<div class="page__info">
			<div class="page__info--title">
				Edit link deals
			</div>
		</div>
		<div>
			<edit-link-deals :link="link" />
		</div>
	</div>
</template>

<script>

	import V2BackBtn from '@/components/v2/ui/V2BackBtn';
	import EditLinkDeals from '@/components/dealLinks/EditLinkDeals';
	import routeParams from '@/mixins/routeParams';
	import api from '@/services/api';

	export default {
		layout: 'v2default',
		metaInfo: {
			title: 'Edit link deals'
		},
		components: {
			EditLinkDeals,
			V2BackBtn
		},
		mixins: [routeParams],
		data () {
			return {
				link: null,
				isWaiting: undefined
			};
		},
		computed: {
			getLinkId () {
				return  this.link?.id;
			},
			getLinkName () {
				return  this.link?.name;
			},
			getBreadcrumbs () {
				return [
					{
						path: '/teaching',
						text: 'Teaching'
					},
					{
						path: '/teaching/links',
						text: 'Deal Links'
					},
					{
						path: `/teaching/links/${this.getLinkId}`,
						text: this.getLinkName
					},
					{
						path: `/teaching/links/${this.getLinkId}/deals`,
						text: 'Deals'
					}
				];
			}
		},
		created () {
			this.fetchLinkData();
		},
		methods: {
			async fetchLinkData () {
				const link = await api.dealLinks.getDealLink({
					linkId: this.$route.params.linkId
				});
				if (!link) {
					this.$store.commit('ui/showError');
					return false;
				}
				this.link = link;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
				this.$store.commit('ui/setLoadingIsHidden');
			}
		}
	};

</script>

<style lang="scss" scoped>
.page__info {
  margin-bottom: 24px;
}
</style>
